<template><div><h1 id="umsatz-pro-jahr" tabindex="-1"><a class="header-anchor" href="#umsatz-pro-jahr"><span>Umsatz pro Jahr</span></a></h1>
<p>Umsatz pro Jahr — Anzeige und Erfassung der Projektkennzahlen auf Jahresbasis.</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Projektkennzahlen, wie Aufwand, Ertrag oder Kosten werden nach Jahren angezeigt. Die Anzeige entspricht derjenigen der Gesamt- Projektkennzahlen in den <RouteLink to="/referenz/refs/ft.refdata.projekte.html" title="Projekte">Projekten.</RouteLink></p>
<p>Pfad: <code v-pre>Projektfinanzierung → Projekte</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Periode</dt>
<dd>Jahr resp. Geschäftsjahr.</dd>
<dt>Kennzahlen</dt>
<dd>Die <a class="link" href="ft.refdata.projekte.html#projektkennzahlen" title="Datenfelder">Kennzahlen</a> werden analog der Beschreibung in den <a class="link" href="ft.refdata.projekte.html" title="Projekte">Projekten</a>Projekten angezeigt.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>N/A</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.projekte.html#projektkennzahlen" title="Datenfelder">Kennzahlen</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.projekte.html#projektkennzahlen" title="Datenfelder">Projekte</RouteLink></p>
</div></template>


